{
  "app": {
    "title": "Gasolina Radar",
    "logoAlt": "Logotipo de Gasolina Radar",
    "owner": "GasolinaRadar",
    "version": "Versión {{version}}",
    "environment": "Entorno: {{environment}}",
    "environmentLabel": {
      "development": "Desarrollo",
      "test": "Pruebas",
      "production": "Producción"
    },
    "navigation": {
      "open": "Abrir navegación",
      "close": "Cerrar navegación"
    }
  },
  "navigation": {
    "home": "Inicio",
    "map": "Mapa",
    "settings": "Configuración",
    "notifications": "Notificaciones",
    "notificationsNew": "Ver notificaciones nuevas",
    "notificationsDefault": "Ver notificaciones",
    "account": "Mi cuenta",
    "alerts": "Mis alertas de precio",
    "favorites": "Mis favoritos",
    "login": "Iniciar sesión",
    "logout": "Cerrar sesión",
    "open": "Abrir navegación",
    "close": "Cerrar navegación"
  },
  "theme": {
    "switchTo": "Cambiar a {{mode}}",
    "light": "claro",
    "dark": "oscuro",
    "ariaLight": "Activar tema claro",
    "ariaDark": "Activar tema oscuro",
    "label": "Tema {{mode}}"
  },
  "shared": {
    "stationCard": {
      "distanceAria": "Distancia a la estación",
      "favorite": {
        "add": "Agregar a favoritos",
        "remove": "Quitar de favoritos"
      },
      "addressAria": "Dirección de la estación",
      "territoryAria": "Información territorial",
      "municipalityAria": "Municipio",
      "grid": {
        "summaryAria": "Resumen de precios destacados",
        "empty": "Sin datos de precio disponibles."
      },
      "prices": {
        "title": "Precios actuales",
        "updated": "Actualizado {{date}}",
        "tableAria": "Tabla de precios",
        "variantCount": {
          "one": "{{count}} variedad",
          "other": "{{count}} variedades"
        },
        "noDiffAria": "Sin variaciones registradas",
        "empty": "No hay datos de precio disponibles."
      },
      "actions": {
        "viewDetails": "Ver detalles"
      },
      "price": {
        "notAvailable": "N/D",
        "perLiter": "{{amount}} €/L",
        "trendFallback": "Variación de precio",
        "diffAria": {
          "up": "{{fuel}} ha subido {{amount}} respecto al último dato.",
          "down": "{{fuel}} ha bajado {{amount}} respecto al último dato.",
          "stable": "{{fuel}} sin variaciones respecto al último dato."
        }
      }
    },
    "timeSeriesChart": {
      "ariaLabel": "Evolución del precio en el tiempo",
      "empty": "No hay datos suficientes para generar la gráfica.",
      "legendAria": "Leyenda de series",
      "tooltip": "{{label}}: {{amount}} · {{date}}"
    },
    "toast": {
      "closeAria": "Cerrar aviso"
    }
  },
  "footer": {
    "legal": "Aviso legal y fuentes",
    "terms": "Condiciones del servicio",
    "privacy": "Política de privacidad",
    "copyright": "© {{year}} {{owner}}"
  },
  "auth": {
    "logoutSuccess": "Sesión cerrada correctamente",
    "login": {
      "title": "Iniciar sesión",
      "recoveryTitle": "Recuperar contraseña",
      "lead": "Accede con tu correo y contraseña para gestionar las fuentes protegidas.",
      "recoveryLead": "Solicita un enlace válido por 15 minutos para restablecer tu contraseña.",
      "emailLabel": "Correo electrónico",
      "emailPlaceholder": "usuario@dominio.com",
      "emailError": "Introduce un correo electrónico válido.",
      "passwordLabel": "Contraseña",
      "passwordPlaceholder": "Mínimo 8 caracteres",
      "passwordShow": "Mostrar contraseña",
      "passwordHide": "Ocultar contraseña",
      "passwordError": "La contraseña debe tener al menos 8 caracteres.",
      "submit": "Entrar",
      "submitting": "Accediendo...",
      "googleDivider": "O continúa con",
      "googleButtonAria": "Iniciar sesión con Google",
      "googleError": "No se pudo validar la cuenta de Google.",
      "noAccount": "¿No tienes cuenta?",
      "registerCta": "Crear cuenta",
      "forgotPassword": "¿Olvidaste tu contraseña?",
      "magicLoginCta": "Acceso mágico",
      "statusPending": "Tu cuenta está pendiente de validación. Un superadministrador debe activarla.",
      "statusDeclined": "Tu cuenta fue declinada. Comunícate con un superadministrador para más detalles.",
      "loginFallback": "Credenciales inválidas o cuenta no registrada.",
      "welcome": "Bienvenido de nuevo, {{email}}",
      "otp": {
        "title": "Hemos enviado un código a tu correo",
        "authenticatorTitle": "Introduce el código del autenticador",
        "subtitle": "Ingresa el código recibido para completar el inicio de sesión. El envío se hará a la dirección {{email}}.",
        "subtitleGeneric": "Ingresa el código recibido para completar el inicio de sesión.",
        "authenticatorSubtitle": "Abre tu app de autenticación y escribe el código de 6 dígitos.",
        "expires": "Caduca en {{time}}",
        "resendIn": "Reenvío disponible en {{time}}",
        "resendAvailable": "Puedes solicitar un nuevo código de inmediato",
        "codeLabel": "Código de verificación",
        "codePlaceholder": "Ejemplo: 123456",
        "codeError": "Introduce el código recibido en tu correo.",
        "submit": "Confirmar código",
        "submitting": "Validando...",
        "resend": "Reenviar código",
        "changeCredentials": "Cambiar correo o contraseña",
        "lockedHint": "El código ya no es válido. Reinicia el inicio de sesión para generar uno nuevo.",
        "errorFallback": "No se pudo validar el código. Verifica el correo recibido.",
        "errorExpired": "El código expiró. Vuelve a iniciar sesión para solicitar uno nuevo.",
        "errorAttempts": "Se alcanzó el límite de intentos. Inicia sesión nuevamente para generar otro código.",
        "errorRateLimit": "Demasiadas solicitudes. Espera un momento antes de reintentar.",
        "toastSent": "Enviamos un código a tu correo. Revisa tu bandeja para continuar.",
        "toastAuthenticator": "Introduce el código de tu app de autenticación para continuar."
      },
      "recovery": {
        "note": "Enviaremos un único enlace activo durante 15 minutos; si ya solicitaste uno, este lo reemplazará.",
        "submit": "Enviar correo de recuperación",
        "submitting": "Enviando enlace...",
        "hint": "Si el correo está registrado, enviaremos un enlace de recuperación.",
        "hintWithExpiration": "Si el correo está registrado, enviaremos un enlace válido hasta {{expiration}}.",
        "fallbackHint": "Si el correo está registrado, enviaremos un enlace de recuperación válido por 15 minutos.",
        "error": "No se pudo iniciar el proceso. Inténtalo nuevamente en unos minutos.",
        "toastError": "No se pudo solicitar la recuperación.",
        "prompt": "¿Ya recuperaste tu cuenta?",
        "backToLogin": "Volver a iniciar sesión"
      },
      "backHome": "Volver al inicio"
    },
    "magicLogin": {
      "title": "Acceso mágico",
      "lead": "Recibe un enlace o código para iniciar sesión sin contraseña.",
      "verifyLead": "Introduce el código que te enviamos por correo para completar el acceso.",
      "emailLabel": "Correo electrónico",
      "emailPlaceholder": "usuario@dominio.com",
      "emailError": "Introduce un correo válido.",
      "requestSubmit": "Enviar acceso mágico",
      "requestSubmitting": "Enviando enlace...",
      "requested": "Si el correo está registrado, enviaremos un enlace y un código temporal.",
      "requestError": "No pudimos iniciar el acceso mágico. Inténtalo de nuevo en unos minutos.",
      "sentTo": "Enviado a {{email}}",
      "expiresAt": "El código caduca el {{expiration}}.",
      "codeLabel": "Código de verificación",
      "codePlaceholder": "Ejemplo: viora-gida-bagon-valzy",
      "codeError": "Introduce el código recibido.",
      "verifySubmit": "Confirmar código",
      "verifySubmitting": "Verificando...",
      "resend": "Reenviar enlace",
      "resendIn": "Reenvío disponible en {{time}}",
      "resendAvailable": "Puedes solicitar un nuevo enlace ahora",
      "changeEmail": "Usar otro correo",
      "backToLogin": "Volver a iniciar sesión"
    },
    "register": {
      "backHome": "Volver al inicio",
      "title": "Crear cuenta",
      "lead": "Registra un usuario para acceder a GasolinaRadar.",
      "googleDivider": "O regístrate con",
      "googleButtonAria": "Registrarse con Google",
      "emailLabel": "Correo electrónico",
      "emailPlaceholder": "usuario@dominio.com",
      "emailError": "Introduce un correo electrónico válido.",
      "passwordLabel": "Contraseña",
      "passwordPlaceholder": "Mínimo 8 caracteres",
      "passwordShow": "Mostrar contraseña",
      "passwordHide": "Ocultar contraseña",
      "passwordError": "La contraseña debe tener al menos 8 caracteres.",
      "termsPrefix": "Acepto los",
      "termsLink": "Términos de uso y tratamiento de datos",
      "termsError": "Debes aceptar los términos para continuar.",
      "submit": "Registrarse",
      "submitting": "Creando cuenta...",
      "disclaimer": "Al registrarte aceptas los términos de uso y autorizas que conservemos tu correo electrónico para gestionar tu acceso y enviarte comunicaciones operativas. Puedes consultarlos en cualquier momento y exportarlos a PDF.",
      "hasAccount": "¿Ya tienes cuenta?",
      "loginCta": "Inicia sesión",
      "successPendingValidation": "Cuenta creada para {{email}}. Un superadministrador debe validarla antes de iniciar sesión.",
      "success": "Cuenta creada para {{email}}.",
      "errorEmailInUse": "El correo ya está registrado. Prueba con otro.",
      "errorGeneric": "No se pudo crear la cuenta. Revisa los datos e inténtalo de nuevo.",
      "googleTermsRequired": "Debes aceptar los términos para registrarte con Google.",
      "googleValidationError": "No se pudo validar la cuenta de Google.",
      "googleErrorEmailInUse": "El correo ya está registrado. Prueba con iniciar sesión.",
      "googleErrorGeneric": "No se pudo crear la cuenta con Google. Inténtalo nuevamente."
    }
  },
  "errors": {
    "notificationsLoad": "No se pudieron cargar tus notificaciones."
  },
  "languageSelector": {
    "label": "Idioma",
    "ariaLabel": "Seleccionar idioma"
  },
  "languages": {
    "es": "Español",
    "en": "English",
    "ca": "Català",
    "fr": "Français",
    "it": "Italiano",
    "pt": "Português",
    "de": "Deutsch"
  },
  "landing": {
    "hero": {
      "eyebrow": "Encuentra el mejor precio cerca de ti",
      "title": "Tu copiloto para elegir la gasolinera perfecta",
      "lead": "Gasolina Radar te muestra precios en tiempo real, estaciones confiables y rutas rápidas. Optimiza cada repostaje con filtros inteligentes y alertas personalizadas.",
      "primaryCta": "Explorar estaciones",
      "secondaryCta": "Crear cuenta gratis",
      "mapAlt": "Vista previa del mapa de Gasolina Radar"
    },
    "meta": {
      "officialData": "Datos oficiales y actualizados",
      "responsive": "Diseñado para móviles y escritorio"
    },
    "stats": {
      "lowestPriceLabel": "Precio más bajo hoy",
      "verifiedStationsLabel": "Estaciones verificadas",
      "syncingPrices": "Sincronizando precios…",
      "syncingStations": "Verificando estaciones…",
      "requestingLocation": "Pidiendo acceso a tu ubicación…",
      "reviewingNearby": "Revisando estaciones cercanas…",
      "noPriceNear": "Aún no podemos mostrar precios en tu zona",
      "noPriceNetwork": "Aún no podemos mostrar precios en la red",
      "priceHint": "{{fuel}} en {{station}} ({{location}})",
      "location": {
        "nearYou": "cerca de ti",
        "reference": "en Madrid",
        "network": "en la red"
      },
      "verifyingNear": "Revisando disponibilidad en tu zona",
      "verifyingNetwork": "Revisando disponibilidad en la red",
      "verifiedSummary": "Estaciones activas y verificadas {{location}}",
      "noData": "Sin datos"
    },
    "features": {
      "eyebrow": "Beneficios clave",
      "title": "Todo lo que necesitas para repostar sin sorpresas",
      "subtitle": "Filtra por combustible, compara precios y guarda tus estaciones favoritas para tenerlas a mano.",
      "interactiveMap": {
        "title": "Mapa interactivo",
        "description": "Explora estaciones cercanas con filtros precisos y vista de cuadrícula o listado en un solo clic."
      },
      "freshPrices": {
        "title": "Precios al día",
        "description": "Datos frescos y trazables para que tomes decisiones informadas sobre dónde repostar."
      }
    },
    "highlights": {
      "eyebrow": "Cobertura completa",
      "title": "Trabajamos con todos los combustibles principales",
      "subtitle": "Las imágenes provienen de nuestro catálogo actualizado.",
      "gasoline95": "Gasolina 95",
      "dieselA": "Gasóleo A",
      "glp": "GLP/Gas",
      "hydrogen": "Hidrógeno",
      "adblue": "AdBlue",
      "renewables": "Renovables"
    }
  },
  "common": {
    "yes": "Sí",
    "no": "No"
  },
  "admin": {
    "common": {
      "back": "← Volver",
      "breadcrumbsLabel": "Ruta de configuración",
      "configurationRoot": "Configuración",
      "comingSoon": "En desarrollo"
    },
    "configuration": {
      "title": "Configuración",
      "lede": "Reúne en un solo lugar las acciones críticas de la plataforma. Accede a los procesos y al resto de herramientas diseñadas para mantener GasolinaRadar bajo control.",
      "comingSoon": "En desarrollo",
      "options": {
        "processes": {
          "title": "Procesos",
          "description": "Consulta el estado de los procesos y habilita nuevas fuentes de ingesta."
        },
        "newRegistrations": {
          "title": "Nuevos registros",
          "description": "Gestiona las altas recientes y activa las cuentas aprobadas."
        },
        "collections": {
          "title": "Colecciones",
          "description": "Gestiona estaciones y tipologías de combustible desde un único lugar."
        },
        "system": {
          "title": "Sistema",
          "description": "Activa o desactiva los módulos base de la plataforma."
        },
        "roles": {
          "title": "Roles y permisos",
          "description": "Muy pronto podrás ajustar el acceso avanzado del equipo."
        },
        "notifications": {
          "title": "Notificaciones",
          "description": "Próximamente enviaremos alertas de incidencias y mantenimientos."
        }
      }
    },
    "collections": {
      "title": "Colecciones",
      "lede": "Gestiona los catálogos principales de GasolinaRadar, como estaciones y tipos de combustible.",
      "options": {
        "stations": {
          "title": "Estaciones",
          "description": "Activa, desactiva y ajusta la información oficial de cada estación."
        },
        "fuels": {
          "title": "Tipos de combustible",
          "description": "Administra claves, etiquetas, iconos y orden de los combustibles disponibles."
        }
      }
    },
    "newRegistrations": {
      "title": "Nuevos registros",
      "lede": "Gestiona las altas recientes, crea usuarios y activa las cuentas aprobadas. Selecciona una opción para continuar.",
      "options": {
        "createUser": {
          "title": "Crear usuario",
          "description": "Registra manualmente cuentas para tu equipo con el rol que necesites."
        },
        "list": {
          "title": "Listado de nuevos registros",
          "description": "Revisa las cuentas recientes, actívalas y decide si enviar correo de bienvenida."
        }
      }
    },
    "processes": {
      "title": "Procesos",
      "lede": "Selecciona el tipo de procesos que deseas administrar. Aquí encontrarás los procesos de carga y más categorías en el futuro.",
      "categories": {
        "loaders": {
          "title": "Procesos de carga",
          "description": "Supervisa y gestiona los procesos que alimentan la plataforma."
        },
        "alerts": {
          "title": "Validación de alertas",
          "description": "Lanza y consulta las ejecuciones de evaluación de alertas de precio."
        }
      }
    },
    "system": {
      "title": "Sistema",
      "lede": "Supervisa y gestiona los módulos base de la plataforma. Selecciona una opción para continuar.",
      "options": {
        "modules": {
          "title": "Módulos del sistema",
          "description": "Gestiona las integraciones base como Redis o RabbitMQ sin reinicios."
        },
        "email": {
          "title": "SMTP / Email",
          "description": "Edita la configuración de correo saliente (servidor, puerto y credenciales)."
        },
        "cache": {
          "title": "Cache",
          "description": "Consulta claves de Redis con TTL y borra entradas obsoletas de forma segura."
        }
      }
    },
    "stations": {
      "header": {
        "eyebrow": "Administración",
        "title": "Estaciones",
        "subtitle": "Usa los filtros para buscar estaciones activas o inactivas y accede rápidamente a su detalle para editar los datos o los precios cargados."
      },
      "actions": {
        "downloadCsv": "Descargar CSV",
        "reload": "Recargar"
      },
      "loader": {
        "searching": "Buscando estaciones…"
      },
      "filters": {
        "search": {
          "label": "Buscador general",
          "placeholder": "Ej: Repsol Madrid"
        },
        "status": {
          "label": "Estado",
          "all": "Todas",
          "active": "Activas",
          "inactive": "Inactivas"
        },
        "pageSize": {
          "label": "Resultados por página"
        },
        "includeHistory": "Incluir historial",
        "province": {
          "label": "Provincia",
          "placeholder": "Ej: Zaragoza"
        },
        "municipality": {
          "label": "Municipio",
          "placeholder": "Ej: Xirivella"
        },
        "postalCode": {
          "label": "Código postal",
          "placeholder": "Ej: 46950"
        },
        "source": {
          "label": "Fuente",
          "placeholder": "Ej: plenergy"
        },
        "fuel": {
          "label": "Combustible",
          "placeholder": "Ej: gasoleoa"
        },
        "geo": {
          "title": "Filtros geoespaciales",
          "lat": "Latitud",
          "lon": "Longitud",
          "radiusKm": "Radio (km)",
          "radiusM": "Radio (m)"
        },
        "apply": "Aplicar filtros",
        "reset": "Reiniciar filtros"
      },
      "bulk": {
        "title": "Opciones rápidas",
        "description": "Selecciona estaciones del listado para activar o desactivar varias a la vez.",
        "selected": {
          "one": "{{count}} seleccionada",
          "other": "{{count}} seleccionadas"
        },
        "markActive": "Marcar como activas",
        "markInactive": "Marcar como inactivas",
        "updating": "Aplicando cambios…",
        "toast": {
          "successOne": "Se actualizó {{count}} estación correctamente.",
          "successMany": "Se actualizaron {{count}} estaciones correctamente.",
          "failureOne": "No se pudo actualizar {{count}} estación seleccionada. Intenta nuevamente.",
          "failureMany": "No se pudieron actualizar {{count}} estaciones seleccionadas."
        }
      },
      "status": {
        "active": "Activa",
        "inactive": "Inactiva"
      },
      "results": {
        "one": "{{count}} resultado encontrado",
        "other": "{{count}} resultados encontrados"
      },
      "table": {
        "selectAll": "Seleccionar todas las estaciones de esta página",
        "headers": {
          "name": "Nombre",
          "sourceId": "ID fuente",
          "address": "Dirección",
          "municipality": "Municipio",
          "source": "Fuente",
          "status": "Estado",
          "updated": "Actualizado",
          "actions": "Acciones"
        },
        "rowSelect": "Seleccionar {{name}}",
        "sourceUnknown": "Sin fuente",
        "viewDetails": "Ver detalle",
        "empty": "No se encontraron estaciones para los filtros seleccionados.",
        "noData": "s/d"
      },
      "pagination": {
        "label": "Paginación",
        "range": "Mostrando {{start}}–{{end}} de {{total}} resultados",
        "summary": "Página {{page}} de {{pages}}",
        "controlsLabel": "Controles de página",
        "previous": "← Anterior",
        "next": "Siguiente →",
        "goToPage": "Ir a página"
      },
      "csv": {
        "none": "No hay estaciones para exportar con los filtros actuales.",
        "fileName": "estaciones_pagina-{{page}}.csv"
      },
      "errors": {
        "load": "No pudimos cargar las estaciones. Intenta nuevamente o revisa tu conexión a internet.",
        "toastLoad": "No se pudo obtener el listado de estaciones"
      }
    }
  },
  "notifications": {
    "eyebrow": "Alertas",
    "title": "Mis notificaciones",
    "description": "Aquí verás las alertas generadas con el método web. Al abrirlas o marcarlas como leídas se limpia el contador de la campana.",
    "actions": {
      "refresh": "Recargar",
      "markAllAsSeen": "Marcar todas como leídas",
      "markAsSeen": "Marcar como leída"
    },
    "badges": {
      "unread": "{{count}} sin leer",
      "read": "Leída"
    },
    "loader": "Cargando notificaciones...",
    "empty": {
      "title": "No tienes notificaciones pendientes",
      "description": "Cuando una alerta de precio con método web se dispare, aparecerá aquí con los detalles de la estación y el combustible."
    },
    "details": {
      "station": {
        "label": "Estación",
        "unknown": "Estación desconocida"
      },
      "fuel": {
        "label": "Combustible",
        "unknown": "Sin especificar",
        "thresholdSummary": "Umbral: {{threshold}} · Valor actual: {{amount}}"
      },
      "action": {
        "label": "Acción",
        "viewStation": "Ver estación",
        "viewMaps": "Ver en Maps"
      }
    },
    "errors": {
      "load": "No se pudieron cargar tus notificaciones.",
      "markOne": "No se pudo marcar la notificación como leída.",
      "markAll": "No se pudieron marcar todas como leídas."
    }
  },
  "account": {
    "header": {
      "eyebrow": "Perfil",
      "title": "Mi cuenta",
      "subtitle": "Consulta los datos básicos asociados a tu sesión.",
      "refresh": "Actualizar datos"
    },
    "loading": {
      "title": "Cargando tu perfil",
      "text": "Recuperando la información de tu cuenta."
    },
    "error": {
      "title": "No se pudo cargar la información",
      "description": "No se pudo cargar la información de tu cuenta."
    },
    "retry": "Reintentar",
    "profile": {
      "emailLabel": "Correo electrónico",
      "role": "Rol: {{role}}",
      "status": {
        "active": "Activa",
        "pending": "Pendiente de activación"
      },
      "otpEmail": "OTP email: {{status}}",
      "otpAuthenticator": "OTP autenticador: {{status}}",
      "otpStatus": {
        "active": "Activo",
        "inactive": "Desactivado"
      },
      "magicLoginEmail": "Acceso mágico: {{status}}",
      "magicLoginStatus": {
        "active": "Activo",
        "inactive": "Desactivado"
      },
      "fields": {
        "id": "Identificador",
        "createdAt": "Creación",
        "updatedAt": "Última actualización"
      }
    },
    "otp": {
      "title": "Verificación en dos pasos",
      "subtitle": "Código de acceso por correo",
      "helper": "Activa el envío de códigos de un solo uso por email para completar el inicio de sesión.",
      "status": {
        "enabled": "Protección activa",
        "disabled": "Protección desactivada"
      },
      "error": "No pudimos actualizar la verificación por correo. Inténtalo nuevamente.",
      "enable": "Activar OTP por email",
      "disable": "Desactivar OTP por email",
      "codeLabel": "Código de verificación",
      "codePlaceholder": "Ejemplo: 123456",
      "codeError": "Ingresa el código enviado por correo.",
      "confirmDisable": "Confirmar desactivación",
      "submitting": "Verificando...",
      "cancelDisable": "Cancelar"
    },
    "otpAuthenticator": {
      "title": "Autenticador",
      "subtitle": "Código de tu app",
      "helper": "Escanea el QR con tu app de autenticación y confirma el código generado.",
      "status": {
        "enabled": "Autenticador activo",
        "disabled": "Autenticador desactivado"
      },
      "verifiedAt": "Activado el {{date}}",
      "setup": "Configurar autenticador",
      "confirm": "Confirmar código",
      "disable": "Desactivar autenticador",
      "cancel": "Cancelar configuración",
      "submitting": "Validando...",
      "codeLabel": "Código del autenticador",
      "codePlaceholder": "Ejemplo: 123456",
      "codeError": "Introduce el código de tu autenticador.",
      "secretLabel": "Clave manual",
      "secretHelper": "Si no puedes escanear el QR, introduce esta clave en tu app.",
      "qrAlt": "QR del autenticador",
      "error": "No pudimos actualizar el autenticador. Inténtalo nuevamente."
    },
    "magicLogin": {
      "title": "Acceso mágico",
      "subtitle": "Inicio de sesión sin contraseña",
      "helper": "Activa los enlaces mágicos enviados por correo para iniciar sesión sin contraseña.",
      "status": {
        "enabled": "Acceso mágico activo",
        "disabled": "Acceso mágico desactivado"
      },
      "error": "No se pudo actualizar la preferencia de acceso mágico. Inténtalo de nuevo.",
      "enable": "Activar acceso mágico",
      "disable": "Desactivar acceso mágico"
    },
    "security": {
      "title": "Seguridad",
      "subtitle": "Actualizar contraseña",
      "helper": "Introduce tu contraseña actual y define una nueva. Todas las sesiones activas se cerrarán al finalizar.",
      "fields": {
        "current": "Contraseña actual",
        "new": "Nueva contraseña",
        "confirm": "Confirmar nueva contraseña"
      },
      "errors": {
        "currentRequired": "Introduce tu contraseña actual.",
        "newRequired": "Debes introducir una contraseña con al menos 8 caracteres.",
        "confirmMismatch": "Las contraseñas deben coincidir.",
        "confirmRequired": "Confirma tu nueva contraseña.",
        "generic": "No se pudo cambiar la contraseña. Verifica tus datos e inténtalo de nuevo."
      },
      "submit": {
        "updating": "Actualizando...",
        "default": "Cambiar contraseña"
      }
    },
    "toasts": {
      "loadError": "No se pudo cargar tu cuenta. Inténtalo de nuevo.",
      "otpEnabled": "Activamos el inicio de sesión con código enviado por correo.",
      "otpDisabled": "Desactivamos el código por correo para tu cuenta.",
      "otpError": "No se pudo actualizar la verificación por correo.",
      "otpAuthenticatorEnabled": "Autenticador activado.",
      "otpAuthenticatorDisabled": "Autenticador desactivado.",
      "otpAuthenticatorSetupError": "No se pudo iniciar la configuración del autenticador.",
      "otpAuthenticatorVerifyError": "No se pudo validar el código del autenticador.",
      "otpAuthenticatorDisableError": "No se pudo desactivar el autenticador.",
      "magicEnabled": "Acceso mágico activado.",
      "magicDisabled": "Acceso mágico desactivado.",
      "magicError": "No se pudo actualizar el acceso mágico.",
      "passwordSuccess": "Contraseña actualizada. Vuelve a iniciar sesión.",
      "passwordError": "No se pudo cambiar la contraseña.",
      "otpChallengeSent": "Te enviamos un código por correo para confirmar la desactivación."
    }
  },
  "favoritesPage": {
    "header": {
      "eyebrow": "Perfil",
      "title": "Mis favoritos",
      "subtitle": "Accede rápido a las estaciones que has marcado como favoritas."
    },
    "actions": {
      "refresh": "Actualizar lista",
      "retry": "Reintentar"
    },
    "states": {
      "loading": {
        "title": "Cargando tus favoritos",
        "text": "Recuperando las estaciones marcadas."
      },
      "error": {
        "title": "No se pudo cargar la información",
        "description": "No se pudieron cargar tus estaciones favoritas."
      },
      "empty": {
        "title": "Aún no tienes favoritos",
        "text": "Marca las estaciones que consultas con frecuencia para acceder a ellas más rápido desde aquí."
      }
    },
    "toasts": {
      "loadError": "No pudimos cargar tus favoritos. Inténtalo de nuevo.",
      "viewError": "No se pudo abrir el detalle de la estación.",
      "identifyError": "No se pudo identificar la estación.",
      "removed": "Estación eliminada de tus favoritos.",
      "removeError": "No pudimos eliminar este favorito. Inténtalo de nuevo."
    }
  },
  "priceAlerts": {
    "header": {
      "eyebrow": "Alertas personalizadas",
      "title": "Alertas de precio",
      "subtitle": "Crea alertas para recibir avisos cuando el precio de tu combustible suba o baje en una estación."
    },
    "actions": {
      "refresh": "Actualizar"
    },
    "form": {
      "eyebrow": "Nueva alerta",
      "title": "Define las condiciones de aviso",
      "helper": "Elige una estación de tus favoritos, selecciona el combustible disponible y marca el umbral de precio.",
      "fields": {
        "station": {
          "label": "Estación",
          "loading": "Cargando favoritos...",
          "placeholder": "Selecciona una estación favorita",
          "empty": "Agrega estaciones a favoritos para crear alertas.",
          "required": "Selecciona una estación para continuar.",
          "error": "No se pudieron cargar tus estaciones favoritas."
        },
        "fuel": {
          "label": "Combustible",
          "placeholder": "Selecciona una opción",
          "empty": "Sin combustibles disponibles",
          "required": "Selecciona un tipo de combustible."
        },
        "threshold": {
          "label": "Umbral (€)",
          "placeholder": "1.450",
          "error": "Introduce un precio válido (mínimo 0.001)."
        },
        "direction": {
          "label": "Dirección",
          "options": {
            "below": "Por debajo de",
            "above": "Por encima de"
          }
        },
        "notification": {
          "label": "Método de notificación",
          "options": {
            "email": "Correo electrónico",
            "webpush": "Notificaciones web"
          },
          "helper": "Recibirás los avisos en tu centro de notificaciones dentro de la aplicación."
        },
        "active": "Activar alerta tras crearla"
      },
      "actions": {
        "submit": "Crear alerta",
        "saving": "Guardando..."
      }
    },
    "list": {
      "eyebrow": "Tus alertas",
      "title": "Gestiona tus configuraciones",
      "helper": "Activa, pausa o elimina alertas existentes.",
      "loading": {
        "title": "Cargando alertas",
        "text": "Recuperando tus configuraciones guardadas."
      },
      "error": {
        "title": "No se pudieron cargar las alertas",
        "description": "Hubo un problema al recuperar tus alertas.",
        "retry": "Reintentar"
      },
      "empty": {
        "title": "Sin alertas activas",
        "text": "Crea tu primera alerta para recibir avisos sobre el precio de tu combustible favorito."
      },
      "card": {
        "status": {
          "active": "Activa",
          "paused": "Pausada"
        },
        "condition": "Condición",
        "notification": "Notificación",
        "lastTrigger": {
          "label": "Último disparo",
          "never": "Aún no se ha disparado"
        },
        "actions": {
          "activate": "Activar",
          "pause": "Pausar",
          "delete": "Eliminar"
        }
      }
    },
    "fallbacks": {
      "station": "Estación"
    },
    "toasts": {
      "loadError": "No pudimos cargar tus alertas. Inténtalo de nuevo.",
      "duplicate": "Ya tienes una alerta creada con la misma estación, combustible, condición y umbral.",
      "duplicateConflict": "Ya existe una alerta con estos mismos datos. Ajusta los valores antes de guardarla.",
      "createSuccess": "Alerta creada correctamente.",
      "createError": "No se pudo crear la alerta. Revisa los datos e inténtalo de nuevo.",
      "activate": "Alerta activada.",
      "pause": "Alerta desactivada.",
      "updateError": "No se pudo actualizar esta alerta.",
      "deleteMissing": "No se pudo eliminar la alerta seleccionada.",
      "deleteSuccess": "Alerta eliminada correctamente.",
      "deleteError": "No se pudo eliminar la alerta.",
      "stationLoadError": "No pudimos recuperar los datos de la estación seleccionada."
    }
  },
  "stations": {
    "header": {
      "title": "Estaciones cercanas",
      "results": "{{count}} resultados encontrados",
      "toggleFilters": {
        "show": "Mostrar filtros",
        "hide": "Ocultar filtros"
      },
      "sortByDistance": "Ordenar por distancia: {{value}}",
      "refresh": "Actualizar resultados"
    },
    "search": {
      "ariaLabel": "Buscador de zonas",
      "title": "Explora por zona",
      "description": "Escribe un municipio, provincia o dirección para ajustar el mapa.",
      "placeholder": "Busca por municipio, provincia o dirección",
      "inputAria": "Buscar ubicación",
      "clear": "Limpiar búsqueda",
      "submit": "Buscar",
      "searching": "Buscando…",
      "locate": "Cerca de mí",
      "locating": "Localizando…",
      "statusSearching": "Buscando ubicaciones…",
      "hint": "Puedes escribir \"Madrid\", \"Barcelona\" o una dirección completa.",
      "shortcutsLabel": "Atajos de teclado",
      "shortcuts": "Usa <kbd>F</kbd> para abrir filtros o <kbd>/</kbd> para ir a la búsqueda.",
      "errors": {
        "empty": "Escribe una zona para buscar.",
        "notFound": "No se encontraron ubicaciones. Prueba con otro término.",
        "generic": "No se pudo completar la búsqueda. Inténtalo de nuevo."
      }
    },
    "map": {
      "ariaLabel": "Mapa de estaciones",
      "placeholder": {
        "searching": "Buscando estaciones en esta zona…",
        "loading": "Preparando el mapa…"
      },
      "reloading": {
        "ariaLabel": "Actualizando estaciones de esta zona",
        "text": "Actualizando estaciones…"
      },
      "legend": {
        "gasoline": "Gasolina",
        "diesel": "Gasóleo"
      },
      "locate": "Mi posición",
      "locating": "Localizando…",
      "errors": {
        "title": "No se pudo cargar el mapa",
        "reload": "Recarga la página y vuelve a intentarlo.",
        "connection": "Comprueba tu conexión y desactiva bloqueadores de scripts o de mapas.",
        "load": "No se pudo cargar el mapa interactivo. Recarga la página o desactiva los bloqueadores de contenido y vuelve a intentarlo.",
        "unavailable": "Leaflet no está disponible en tu navegador. Intenta recargar la página y revisa si algún bloqueador está impidiendo la carga de scripts."
      },
      "status": {
        "searching": "Buscando estaciones en esta zona…",
        "loading": "Cargando estaciones en el mapa…",
        "empty": "No hay estaciones para mostrar en esta zona."
      },
      "ranking": {
        "title": "Top mejores precios · {{fuel}}",
        "ariaLabel": "Estaciones con mejor precio"
      },
      "rankingBadge": "#{{rank}} en mejor precio ({{fuel}})",
      "direction": "Cómo llegar",
      "geolocation": {
        "blockedTitle": "La geolocalización está bloqueada.",
        "blockedSubtitle": "Activa el permiso de ubicación para centrar el mapa en tu posición. Sigue estos pasos:",
        "steps": {
          "first": "Haz clic en el candado de la barra de direcciones.",
          "second": "Busca \"Ubicación\" y selecciona \"Permitir\" para este sitio.",
          "third": "Recarga la página y vuelve a pulsar \"Cerca de mí\"."
        }
      }
    },
    "list": {
      "ariaLabel": "Listado de estaciones",
      "empty": "No se encontraron estaciones con los filtros seleccionados.",
      "controls": {
        "ariaLabel": "Controles del listado",
        "pageSize": "Resultados por página",
        "sort": "Ordenar por",
        "exportCsv": "Exportar CSV",
        "viewModeAria": "Cambiar vista",
        "viewModes": {
          "grid": "Cuadrícula",
          "list": "Lista"
        },
        "sortOptions": {
          "distanceAsc": "Cercanía",
          "distanceDesc": "Lejanía",
          "priceAsc": "Precio más barato",
          "priceDesc": "Precio más caro"
        }
      },
      "table": {
        "ariaLabel": "Vista tabular de estaciones",
        "columns": {
          "name": "Gasolinera",
          "province": "Provincia",
          "municipality": "Municipio",
          "featured": "Productos destacados",
          "actions": "Acciones"
        },
        "noData": "Sin datos disponibles",
        "notAvailable": "N/D",
        "viewDetails": "Ver detalles"
      },
      "pagination": {
        "ariaLabel": "Paginación",
        "range": "Mostrando {{start}}–{{end}} de {{total}} resultados",
        "summary": "Página {{current}} de {{total}}",
        "controlsAriaLabel": "Controles de página",
        "pagesAriaLabel": "Ir a página",
        "previous": "← Anterior",
        "next": "Siguiente →"
      }
    },
    "filters": {
      "ariaLabel": "Filtros de estaciones",
      "title": "Filtra tu búsqueda",
      "subtitle": "Refina los resultados por combustible, zona o distancia.",
      "close": "Cerrar filtros",
      "fabLabel": "Filtros"
    },
    "favorites": {
      "loginRequired": "Inicia sesión para guardar tus estaciones favoritas.",
      "identifyError": "No se pudo identificar la estación.",
      "alreadyFavorite": "Esta estación ya estaba en tus favoritos.",
      "removed": "Estación eliminada de favoritos.",
      "added": "Estación añadida a favoritos.",
      "updateError": "No pudimos actualizar tus favoritos. Inténtalo de nuevo.",
      "loadError": "No se pudieron cargar tus favoritos."
    },
    "geolocation": {
      "notAvailable": "La geolocalización no está disponible en este dispositivo.",
      "notSupported": "Tu navegador no es compatible con geolocalización.",
      "blocked": "La API de geolocalización está bloqueada en tu navegador. Activa el permiso para continuar.",
      "timeout": "La solicitud de ubicación tardó demasiado. Inténtalo de nuevo.",
      "denied": "Tu navegador bloqueó la geolocalización. Permite el acceso para centrar el mapa en tu posición.",
      "positionUnavailable": "No se pudo determinar tu ubicación actual. Inténtalo de nuevo en unos instantes.",
      "requestTimeout": "La solicitud de ubicación superó el tiempo de espera. Inténtalo nuevamente.",
      "genericError": "Ocurrió un error al obtener tu ubicación. Vuelve a intentarlo más tarde."
    },
    "csv": {
      "filename": "gasolineras-pagina-{{page}}.csv",
      "headers": {
        "name": "Nombre",
        "distance": "Distancia",
        "address": "Dirección",
        "province": "Provincia",
        "municipality": "Municipio",
        "featuredProduct": "Producto destacado",
        "price": "Precio"
      },
      "noData": "Sin datos",
      "zeroDistance": "0 km",
      "distanceWithUnit": "{{value}} km"
    },
    "priceDiff": {
      "stable": "{{fuel}} sin variaciones respecto al último dato.",
      "trend": "{{fuel}} {{direction}} {{amount}} respecto al último dato.",
      "direction": {
        "up": "ha subido",
        "down": "ha bajado"
      }
    }
  },
  "stationDetails": {
    "back": "← Volver al listado",
    "logoAlt": "Logo de {{station}}",
    "header": {
      "schedule": "Horario: {{schedule}}",
      "updated": "Actualizado: {{date}}",
      "favorites": {
        "add": "Agregar a favoritos",
        "remove": "Quitar de favoritos"
      }
    },
    "priceChips": {
      "ariaLabel": "Evolución reciente de precios",
      "labels": {
        "noChanges": "{{fuel}}: sin variaciones recientes",
        "noChangeZero": "{{fuel}}: sin cambios ({{diff}})",
        "trend": {
          "up": "{{fuel}}: subió {{diff}}",
          "down": "{{fuel}}: bajó {{diff}}"
        }
      }
    },
    "overview": {
      "map": {
        "title": "Ubicación",
        "hint": "Visualiza la posición exacta de la gasolinera en el mapa interactivo.",
        "cta": "Cómo llegar",
        "ctaAria": "Abrir indicaciones en Google Maps",
        "loading": "Cargando mapa…",
        "error": {
          "title": "No se pudo cargar el mapa.",
          "hint": "Recarga la página e inténtalo de nuevo."
        },
        "unavailable": {
          "title": "Ubicación no disponible.",
          "hint": "Esta estación no dispone de coordenadas públicas."
        }
      },
      "metrics": {
        "title": "Métricas históricas",
        "hint": "Resumen estadístico calculado a partir del histórico de precios disponible.",
        "average": "Promedio",
        "min": "Mínimo",
        "max": "Máximo",
        "latest": "Última variación"
      }
    },
    "history": {
      "title": "Histórico de precios",
      "hint": "Explora la evolución temporal por familia de carburante y compara las variaciones diarias.",
      "rangeAria": "Configurar rango de fechas",
      "from": "Desde",
      "to": "Hasta",
      "presetsAria": "Atajos de rango de fechas",
      "preset": {
        "currentMonth": "Mes actual",
        "ytd": "YTD",
        "oneYear": "Últimos 12 meses",
        "all": "Todo el histórico"
      },
      "categoryDescription": "Comparativa de precios registrados para los productos de {{category}}.",
      "records": "{{count}} registros históricos",
      "exportCsv": "Exportar CSV",
      "table": {
        "date": "Fecha",
        "price": "Precio",
        "variation": "Variación",
        "paginationAria": "Paginación de histórico",
        "previous": "Anterior",
        "next": "Siguiente",
        "range": "{{start}}-{{end}} de {{total}}"
      }
    },
    "csv": {
      "filename": "precios-{{category}}-{{fuel}}.csv",
      "headers": {
        "fuel": "Combustible",
        "date": "Fecha",
        "price": "Precio (€)",
        "diff": "Variación (€)"
      }
    },
    "common": {
      "notAvailable": "N/D",
      "noData": "Sin datos",
      "plusMinus": "±"
    },
    "fuels": {
      "gasoleoa": "Gasóleo A",
      "gasoleopremium": "Gasóleo Premium",
      "gasolina95e5": "Gasolina 95 E5",
      "gasolina95e5premium": "Gasolina 95 Premium",
      "gasolina95e5plus": "Gasolina 95 Plus",
      "gasolina98e5": "Gasolina 98 E5",
      "glp": "GLP",
      "gnc": "GNC",
      "gnl": "GNL",
      "hidrogeno": "Hidrógeno",
      "adblue": "AdBlue"
    },
    "categories": {
      "gasoleo": "Gasóleo",
      "gasolina": "Gasolina",
      "adblue": "AdBlue",
      "otros": "Otros combustibles"
    },
    "empty": "No se ha encontrado la estación solicitada."
  },
  "legalDisclaimer": {
    "hero": {
      "eyebrow": "Aviso legal y reconocimiento de fuentes",
      "title": "Uso de logos, marcas y datos procedentes de terceros",
      "lede": "GasolinaRadar se alimenta de datos públicos y de registros operativos de distintas estaciones de servicio. El objetivo de esta página es dejar absolutamente claro que los logos, marcas, fotografías y datos originales pertenecen a sus titulares, y que el uso que hacemos es meramente informativo y respetuoso con los derechos de propiedad intelectual y las licencias de uso aplicables."
    },
    "actions": {
      "home": "Volver al inicio",
      "stations": "Explorar estaciones"
    },
    "sections": {
      "ownership": {
        "title": "1. Titularidad de logos y marcas",
        "paragraph1": "Los logotipos, isotipos, imagotipos, colores corporativos y cualesquiera otros signos distintivos mostrados en la plataforma pertenecen a sus respectivos propietarios. Se utilizan únicamente para identificar a cada operador o estación de servicio y facilitar la búsqueda visual por parte de la comunidad. No otorgamos ni reclamamos derechos sobre estas marcas, ni implican patrocinio, afiliación o endoso alguno por parte de sus titulares.",
        "paragraph2": "Si eres titular de una marca y deseas ajustar la forma en la que se presenta tu identidad, ponte en contacto con nuestro equipo para revisar la versión más actualizada disponible o retirar recursos obsoletos."
      },
      "sources": {
        "title": "2. Procedencia de los datos y registros",
        "paragraph1": "Las fichas de estaciones y los precios se nutren de fuentes públicas, registros de log de procesos de carga y datos aportados por terceros bajo licencias abiertas. No somos autores del contenido original ni manipulamos los valores con fines comerciales. Nuestro rol se limita a recopilar, depurar y mostrar la información de forma coherente para uso de la comunidad y de profesionales del sector.",
        "list": {
          "updates": "Indicamos siempre que es posible la fecha de última actualización y el origen de los datos.",
          "logs": "Los logs operativos se utilizan únicamente para trazabilidad y transparencia. Se anonimiza cualquier dato personal accidental que pueda aparecer en ellos.",
          "reports": "Cualquier error, desactualización o falta de contexto puede reportarse para que revisemos la fuente y, si procede, corrijamos o eliminemos el dato."
        }
      },
      "usage": {
        "title": "3. Uso permitido del material mostrado",
        "paragraph1": "El uso de los logos y marcas queda limitado a su visualización dentro de GasolinaRadar. No se permite su descarga, redistribución, modificación o utilización en campañas publicitarias salvo autorización expresa del titular de cada marca. La descarga de datos está condicionada a las licencias de la fuente original; en ningún caso puede interpretarse que otorgamos derechos adicionales.",
        "paragraph2": "Cuando la fuente aplique licencias abiertas (por ejemplo, datos abiertos gubernamentales), se respetan sus términos específicos de atribución, limitación de responsabilidad y restricciones de reutilización. Invitamos a los usuarios a consultar dichas licencias antes de usar los datos fuera de la plataforma."
      },
      "liability": {
        "title": "4. Limitaciones de responsabilidad",
        "paragraph1": "La información que se muestra se ofrece “tal cual” y puede contener retrasos, inconsistencias o cambios operativos de terceros. No garantizamos exactitud absoluta ni asumimos responsabilidad por decisiones tomadas exclusivamente con base en los datos publicados. Recomendamos validar información crítica directamente con la estación correspondiente o con el organismo oficial que publica el dato.",
        "list": {
          "infoOnly": "No gestionamos transacciones comerciales ni reservas. Solo mostramos datos informativos.",
          "misuse": "No respondemos por el uso indebido de logos o marcas realizado por terceros fuera de la plataforma.",
          "takedown": "Podemos retirar temporalmente contenidos si existe duda razonable sobre su titularidad, licencia o exactitud, hasta que la revisión concluya."
        }
      },
      "requests": {
        "title": "5. Peticiones de retirada o aclaración",
        "paragraph1": "Si consideras que algún logo, marca, fotografía o dato publicado vulnera derechos, licencias o deberes de atribución, contáctanos con la mayor cantidad de detalle posible (URL, captura, identificación de la fuente y acreditación de titularidad). Revisaremos el caso con prioridad y adoptaremos las medidas necesarias, que pueden incluir la sustitución del recurso, la cita correcta de la fuente o su retirada inmediata.",
        "contactEmail": {
          "label": "Correo de contacto dedicado:",
          "value": "themaxter99+legal-gasolinaradar@gmail.com"
        },
        "subject": {
          "label": "Asunto recomendado:",
          "value": "\"Solicitud de revisión de logo o dato\""
        },
        "sla": {
          "label": "Tiempo objetivo de respuesta:",
          "value": "Dentro de 5 días hábiles."
        }
      },
      "acknowledgements": {
        "title": "6. Reconocimiento a las fuentes",
        "paragraph1": "Agradecemos públicamente a las entidades que publican información de forma abierta. Siempre que sea posible incluimos atribuciones visibles o metadatos que referencien la procedencia de los datos. Este proyecto se mantiene comprometido con los principios de transparencia, reutilización responsable y respeto a la propiedad intelectual de terceros.",
        "list": {
          "cite": "Citamos a los organismos oficiales, portales de datos abiertos y proveedores que alimentan el servicio.",
          "freshness": "Indicamos la fecha de ingestión de cada fuente para que los usuarios conozcan su frescura.",
          "changes": "Publicamos cambios relevantes en este aviso cuando se incorporan nuevas fuentes o licencias."
        }
      },
      "updates": {
        "title": "7. Actualizaciones del aviso",
        "paragraph1": "Este aviso se revisa periódicamente para reflejar nuevas fuentes, cambios en licencias o ajustes de procesos de ingestión. Las modificaciones importantes se comunicarán en el panel de administración y, cuando proceda, por correo electrónico a los colaboradores afectados. La fecha de última revisión figura a continuación.",
        "lastUpdated": {
          "label": "Última actualización:",
          "value": "20 de noviembre de 2025"
        },
        "owner": {
          "label": "Responsable de la publicación:",
          "value": "Equipo de cumplimiento y datos de GasolinaRadar"
        }
      }
    }
  }
}
